<template>
  <vx-card class="saved_review mb-2" @contextmenu.prevent="openContextMenu">
    <template v-slot:title>
      <div class="m-4">
        <div v-if="showSentiment">
          <TextStory :story="story"/>
        </div>
        <div v-if="moodTracker">
          <div class="font-bold text-black text-2xl flex">mood check-in

            <div class="ml-2 flex">
              <LifeArea v-for="lifeArea in story.whyDoYouFeelThatWay" :lifeArea="lifeArea" class="mr-1" :showIcon="true" :hideText="true"/>
            </div>
          </div>
          <MoodTracker :story="story"/>
        </div>

        <div v-if="lifeBalance">
          <div class="font-bold text-black text-2xl">life balance</div>
          <LifeBalance :story="story"/>
        </div>

        <slot></slot>
      </div>
    </template>

    <template v-if="story.storyType" v-slot:actions>
      <div @click.stop="" class="flex items-center">

        <feather-icon icon="MoreVerticalIcon" @click="openContextMenu" :class="actionElementCss" svgClasses="h-5 w-5" />
        <context-menu id="routines-context-menu" ref="storyCtxMenu">
          <ContextMenuItem title="edit" icon="EditIcon" @contextMenuClicked="$emit('edit', story)"/>

          <ContextMenuItem title="delete" icon="Trash2Icon" @contextMenuClicked="$emit('delete', story)" color="text-danger"/>
        </context-menu>
      </div>
    </template>
  </vx-card>

</template>

<script>
// import JourneyDay from './JourneyDay'
// import * as DateHelper from '@/helpers/date'
import _ from 'lodash'
import Story from '@/models/Story'
import MoodTracker from './MoodTracker'
import LifeBalance from './LifeBalance'
import TextStory from './TextStory'
import LifeArea from './LifeArea'

export default {
  components: {
    MoodTracker,
    LifeBalance,
    TextStory,
    LifeArea

  },
  props: ['story'],
  data () {
    return {
    }
  },
  computed: {
    showSentiment () {
      return this.storyEntity.sentiment()
    },
    moodTracker () {
      return this.storyEntity.moodTracker()
    },
    lifeBalance () {
      return this.storyEntity.lifeBalance()
    },
    storyEntity () {
      return new Story(this.story)
    },

  },
  methods: {
    openContextMenu () {
      // this.$root.$emit('closeAllContextMenus')

      if (this.$refs.storyCtxMenu) {
        this.$refs.storyCtxMenu.open()
      }
    },
  },
  created () {
    this.$root.$on('closeAllContextMenus', () => {
      if (this.$refs.storyCtxMenu) {
        this.$refs.storyCtxMenu.ctxVisible = false
      }
    })
  },
}
</script>

<style lang="scss">

.saved_review {
  .vx-card__header {
    padding: 0.6rem
  }
}

</style>
